import type { ProjectReportsGatewayPort } from "@/application/project-reports/ports/ProjectReportsGatewayPort";
import type { ProjectReportDTO, UpdateProjectReportDTO } from "@/application/project-reports/dtos/ProjectReportDTO";

export class UpdateProjectReportUseCase {
  constructor(private readonly gateway: ProjectReportsGatewayPort) {}

  async execute(
    projectId: string,
    reportId: string,
    data: UpdateProjectReportDTO,
    _currentReport?: ProjectReportDTO
  ): Promise<ProjectReportDTO> {
  void _currentReport;
    if (!projectId || projectId.trim().length === 0) {
      throw new Error("Project ID is required");
    }
    if (!reportId || reportId.trim().length === 0) {
      throw new Error("Report ID is required");
    }

    return this.gateway.update(projectId, reportId, data);
  }
}
